import { render, staticRenderFns } from "./hqzcDetail.vue?vue&type=template&id=96b8b1f6&scoped=true"
import script from "./hqzcDetail.vue?vue&type=script&lang=js"
export * from "./hqzcDetail.vue?vue&type=script&lang=js"
import style0 from "./hqzcDetail.vue?vue&type=style&index=0&id=96b8b1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b8b1f6",
  null
  
)

export default component.exports